import { Box, Button, ButtonProps } from 'grommet';
import { Project } from 'lib/api';
import { observer } from 'mobx-react-lite';
import { SVGProps, useEffect, useState } from 'react';
import { useUserStore } from 'src/context';
import { FavoriteFilled } from './icons/FilledIcons';

export type FavoriteButtonProps = {
  project: Project;
  buttonProps?: ButtonProps;
  iconProps?: Omit<SVGProps<SVGSVGElement>, 'ref'>;
  size?: string;
  hoveredSize?: string;
};

export const FavoriteButton = observer(
  ({ project, buttonProps, iconProps, size = '24px', hoveredSize = '26px' }: FavoriteButtonProps) => {
    /** Context **/
    const userStore = useUserStore();

    /** State **/
    const [favs, setFavs] = useState<string[]>([]);
    const [isHovered, setIsHovered] = useState(false);

    /** Methods **/
    const toggleLike = async (projectId: string) => {
      const newfavs = favs.includes(projectId) ? favs.filter((id) => id !== projectId) : [...favs, projectId];
      userStore.updateProfile({ ...userStore.user, favorite_project_ids: newfavs });
    };

    /** Effects */

    useEffect(() => {
      if (!userStore.user.favorite_project_ids) return;
      setFavs(userStore.user.favorite_project_ids);
    }, [userStore.user.favorite_project_ids]);

    /** Render */
    return (
      <Box justify="center" align="center" width={hoveredSize} height={hoveredSize}>
        <Button
          plain
          onMouseOver={() => setIsHovered(true)}
          onMouseOut={() => setIsHovered(false)}
          icon={
            <FavoriteFilled
              $filled={favs.includes(project.id) ? 'true' : undefined}
              size={isHovered ? hoveredSize : size}
              {...iconProps}
            />
          }
          // hoverIndicator
          onClick={() => toggleLike(project.id)}
          tip="Favorite this project"
          {...buttonProps}
        />
      </Box>
    );
  }
);
